import * as React from 'react';

export interface IAutocompleteResultProps{
    id: number;
    query: string;
    searchTerm: string;
    isActive: boolean;

    onResultActive: () => void;
    onResultClick: () => void;
}

// XXX: why is this class duplicated?
/// <summary>
/// Renders individual autocomplete items
/// </summary>
export class AutocompleteResult extends React.Component<IAutocompleteResultProps, any> {

    get classes() {
        return this.props.isActive ? 'highlighted' : '';
    }

    get highlightedAutoComplete() {
        // Want to escape all '\' characters for the Regex.  Also what to trim spaces and make it lower case for consistency
        var highlightedTerm = this.props.searchTerm
            .replace('\\', '\\\\')
            .replace('(', '\\(')
            .replace(')', '\\)')
            .trim()
            .toLowerCase();
        return this.props.query.replace(new RegExp('(' + highlightedTerm + ')'), '<strong>$1</strong>');
    }

    /* XXX move this to a connected component
    OnClickEventHandler() {
        this.props.onSearchTermChanged(this.props.query);
        this.props.dispatch(setActiveHit(-1));
        this.props.dispatch(setAutocompleteActive(false));
        this.props.dispatch(fetchResults(false, false, false, true));
        (document.getElementById('txt_search') as HTMLInputElement).value = this.props.query;
        //(document.getElementById('txt_search') as HTMLInputElement).focus();
        multiPushInUrlQuery({ k: this.props.query, page: '1', context: ContextIds.all });
    }
    */

    render() {
        return (
            <li className={this.classes} data-value={(this.props.id + 1)}
                onMouseEnter={this.props.onResultActive}
                onClick={this.props.onResultClick}>

                <span dangerouslySetInnerHTML={{ __html: this.highlightedAutoComplete }} />
            </li>
        );
    }
}
